import React, { Component } from 'react';
import * as Config from '../../config/Config';
import * as Common from '../../helpers/Common';
import BookChat from './BookChat';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/lib/react-responsive-modal.css';
import moment from 'moment';

import BigCalendar from 'react-big-calendar';
// a localizer for BigCalendar
BigCalendar.momentLocalizer(moment);

const $= window.$;

class ChatBook extends Component {
  constructor(props) {
    super(props);
    
        this.state={
          events : [],
          open: false,
          no_ecoach : '',
          chat_existance : '',
          no_ecoach_show : 'block',
          show : 'none',
          hide :'none',
        };
        
       this.getPopup = this.getPopup.bind(this);
       this.onCloseModal = this.onCloseModal.bind(this);
  }


  componentWillReceiveProps(nextProps) {
    this.getEvents();
  }

  getPopup(event){
      this.setState({ 
            open: true,
            BookComp : <BookChat events={event} closeModal={this.onCloseModal} />
      });     
  }
 
  onCloseModal(){
    this.setState({ open: false });
  };
 
  getEvents(){
    Common.reactLoader("show", "Please wait...");
      let learner_id = Common.getUserData("id", true);
      let pinid = Common.getUserData("pinID", true);
      let pinno = Common.getUserData("pinNo", true);
      fetch(Config.domainUrl+'ecoach-chat/get-events', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization':'Bearer ' +Common.getTokenData()
            },

              body: JSON.stringify({
                learner_id:learner_id,pinid:pinid,pinno:pinno,
              })
            }).then((response) => response.json())
           .then((responseJson) => {
            // alert(JSON.stringify(responseJson));
            Common.reactLoader("hide");
            if(responseJson.status != 0){
              if(responseJson.no_ecoach != ""){
                this.setState({
                    no_ecoach_show : 'block',
                    show : 'none',
                    hide :'none',
                })
              }
              else if (responseJson.chat_existance) {
                this.setState({
                    no_ecoach_show : 'none',
                    show : 'block',
                    hide :'none',
                }) 
              }
              else{
                  this.setState({
                      no_ecoach_show : 'none',
                      show : 'none',
                      hide :'block',
                      events : responseJson.events,
                      no_ecoach : responseJson.no_ecoach,
                      chat_existance : responseJson.chat_existance,
                  });
              }
            }
       });
       Common.downTabClose();
  }

   

    componentDidMount() {
      this.getEvents();
    }




    render() {
      const {open} = this.state;
      const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];

      let d=new Date(), jDate=d.getDate(), jMonth=monthNames[d.getMonth()], jYear=d.getFullYear();

      return (
        <div>
          <div className='light-graybox' style={{display:this.state.no_ecoach_show}}><p>No E Coach has been assigned to you. This feature will be active only if an E Coach is assigned.</p></div>
          <div className='success-msg' style={{display:this.state.show}}>You may request for a chat after completing the current chat request.</div>
          <div className="chat" style={{display:this.state.hide}}>
              <div className="telecal-reqcalendar">
                <h2 className="recap-blue-title">E Coach's available slots for telecalls</h2>
                <p><span className="bluebgspan"></span> - Dates with this color background denotes availability of E Coach</p>
                <p style={{textAlign:'center'}}>{jMonth+' '+jYear}</p>
              </div>
                <BigCalendar
                  popup
                  selectable
                  style={{height: '520px',width:'100%'}}
                  views={['month']} 
                  defaultView='month'
                  toolbar={false}
                  events={this.state.events}
                  onSelectEvent={event => 
                    this.getPopup(event)
                  }
                />
              <Modal open={open} onClose={this.onCloseModal} >
                 {this.state.BookComp}
              </Modal>
          </div>
        </div>
      );
    }
}

export default ChatBook;



// WEBPACK FOOTER //
// ./src/personal_interactions/ecoach_request/ChatBook.js